import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	groupByLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.group-by-label',
		defaultMessage: 'Group by',
		description: 'A label that prefixes a control to select how issues are grouped',
	},
});
